/* istanbul ignore file */
import React from 'react'
import { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
// @ts-ignore no types
import _ from 'lodash'
import {
  Text,
  Grid,
  hooks,
  // @ts-ignore no types
} from '@adc/ui-adc'
import { SCREEN_BREAKPOINT_NAMES } from 'common/constants/screen'
import { getFieldValue, ListingValueField, pruneFields } from './utils'
// @ts-ignore no types
import cls from './index.scss'

const cx = _cx.bind(cls)

const PropertyDetailsRow = ({
  listing,
}: {
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
}) => {
  const currentScreenType = hooks.useBreakpoints()
  const isSmallScreen = [
    SCREEN_BREAKPOINT_NAMES.MOBILE,
    SCREEN_BREAKPOINT_NAMES.TABLET,
  ].includes(currentScreenType)
  const specialNotes =
    listing.listing_remarks?.special_notes ||
    listing.listing_remarks?.mls_comment

  return (
    <div className={cx('property-details')}>
      <Grid className={cx('property-details-grid')} padded>
        {pruneFields(listing).map(
          (field: ListingValueField[], index: number) => {
            const firstField = field[0]
            const firstFieldValue = getFieldValue(firstField)
            const firstLabel = firstField.label
            const hideFirstField = firstField.hideIfNull && !firstFieldValue
            // Just don't show the second value if it doesn't exists. This can only happen once because of `pruneFields`
            const secondField = _.get(field, '[1]', { hideIfNull: true })
            // @ts-ignore TODO:
            const secondFieldValue = getFieldValue(secondField)
            // @ts-ignore TODO:
            const secondLabel = _.isFunction(secondField.label)
              ? // @ts-ignore TODO:
                secondField.label(listing)
              : // @ts-ignore TODO:
                secondField.label
            const hideSecondField = secondField.hideIfNull && !secondFieldValue

            const firstColumnValue = (
              <>
                <Grid.Column
                  mobile={6}
                  computer={3}
                  className={cx('property-details-column', 'first-column')}
                >
                  <Text color='gray' data-elm-id={`${firstField.elmId}_label`}>
                    {!hideFirstField && firstLabel}
                  </Text>
                </Grid.Column>
                <Grid.Column
                  mobile={10}
                  computer={5}
                  className={cx('property-details-column')}
                >
                  {!hideFirstField &&
                    PropertyDetailFieldValue(firstFieldValue, firstField.elmId)}
                </Grid.Column>
              </>
            )
            const secondColumnValue = (
              <>
                <Grid.Column
                  mobile={6}
                  computer={3}
                  className={cx('property-details-column', {
                    hidden: hideSecondField,
                  })}
                >
                  {/* @ts-ignore TODO: */}
                  <Text color='gray' data-elm-id={`${secondField.elmId}_label`}>
                    {!hideSecondField && secondLabel}
                  </Text>
                </Grid.Column>
                <Grid.Column
                  mobile={10}
                  computer={5}
                  className={cx('property-details-column', {
                    hidden: hideSecondField,
                  })}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {!hideSecondField &&
                    PropertyDetailFieldValue(
                      secondFieldValue,
                      // @ts-ignore TODO:
                      secondField.elmId
                    )}
                </Grid.Column>
              </>
            )
            if (isSmallScreen) {
              return (
                <React.Fragment key={index}>
                  <Grid.Row className={cx('property-details-row')}>
                    {firstColumnValue}
                  </Grid.Row>
                  <Grid.Row className={cx('property-details-row')}>
                    {secondColumnValue}
                  </Grid.Row>
                </React.Fragment>
              )
            }
            return (
              <Grid.Row className={cx('property-details-row')} key={index}>
                {firstColumnValue}
                {secondColumnValue}
              </Grid.Row>
            )
          }
        )}
        {specialNotes && (
          <Grid.Row className={cx('property-details-row')}>
            <Grid.Column
              mobile={6}
              tablet={6}
              computer={3}
              className={cx('property-details-column', 'first-column')}
            >
              <Text color='gray' data-elm-id='special_notes_label'>
                Special Notes
              </Text>
            </Grid.Column>
            <Grid.Column
              mobile={10}
              tablet={10}
              computer={13}
              className={cx('property-details-column')}
            >
              <Text
                color='gray'
                weight='heavy'
                data-elm-id='special_notes_value'
              >
                {specialNotes}
              </Text>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </div>
  )
}
PropertyDetailsRow.propTypes = {
  listing: PropTypes.object.isRequired,
}

const PropertyDetailFieldValue = (fieldValue?: string, fieldName?: string) =>
  fieldValue && (
    <Text color='gray' weight='heavy' data-elm-id={`${fieldName}_value`}>
      {fieldValue}
    </Text>
  )

export default PropertyDetailsRow
